var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"lg":"6","md":"9"}},[_c('summary-box',{staticClass:"shadow-sm",attrs:{"items":_vm.items,"loading":_vm.loading}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }